import React, { useState ,useContext} from "react";
import { useMediaQuery } from "@mui/material";
import { DashboardContext } from "re_redesigned_componnents/context/Context";
function PermanentDrawerWrapper({ children }) {
  const sidebar_width = 235;
  const isLargeScreen = useMediaQuery('(min-width:767px)');
  const [toggles, setToggle] = useState(true);
  const {toggle,showMenu} = useContext(DashboardContext)
  return (
    <>
    {/* <button onClick={()=>{
      setToggle((prev)=>{
return !prev
      })
    }}>...</button> */}
      <div
        style={{
          height: "100%",
          // width: toggle ? `${sidebar_width}px` : "0px", // Change width based on toggle
          backgroundColor: "red",
          transform: toggles ? "translateX(0%)" : "translateX(-110%)",
          transition: "transform 0.15s ease-in-out,width 0.15s ease-in-out",
          position: !isLargeScreen ? "absolute" : "",
          zIndex: !isLargeScreen ? 25 : 0
        }}
        
      >
        {children}
      </div>
    </>
  );
}

export default PermanentDrawerWrapper;
